import { OrderProduct } from '@app/components/orders/OrderProduct/OrderProduct';
import { StockTypeGroup } from '@app/components/orders/OrderProducts/types';
import { getOrderDetails } from '@app/ducks/order';
import { getTotalQuantityInProduct } from '@app/logic/Orders';
import { formatPriceWithCurrencyAffix } from '@app/logic/price';
import { getOrderedProductsById } from '@app/logic/products';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { OrderProductsGroupHeader } from '../OrderProductsGroupHeader';
import { OrderProductsGroupHeaderItem } from '../OrderProductsGroupHeaderItem';
import { OrderProductsGroupHeaderItems } from '../OrderProductsGroupHeaderItems';

interface Props {
  group: StockTypeGroup;
}

export const OrderStockTypeGroup = ({ group }: Props) => {
  const orderDetails = useSelector(getOrderDetails);
  const { t } = useTranslation(['common', 'totals', 'products']);
  const units = React.useMemo(() => {
    return group.orderProducts.reduce((acc, product) => acc + getTotalQuantityInProduct(product.items), 0);
  }, [group.orderProducts]);

  const totalPrice = React.useMemo(() => {
    return group.orderProducts.reduce((acc, product) => acc + product.totalPriceAsNumber, 0);
  }, [group.orderProducts]);

  return (
    <div>
      <OrderProductsGroupHeader>
        <OrderProductsGroupHeaderItems>
          <OrderProductsGroupHeaderItem value={group.label} label={t('common:stock_type')} />
        </OrderProductsGroupHeaderItems>
        <OrderProductsGroupHeaderItems>
          <OrderProductsGroupHeaderItem value={group.products.length} label={t('products:product', { count: group.products.length })} />
          <OrderProductsGroupHeaderItem value={units} label={t('common:unit', { count: units })} />
          <OrderProductsGroupHeaderItem
            value={formatPriceWithCurrencyAffix(orderDetails.currency)(totalPrice)}
            label={t('totals:total_one')}
          />
        </OrderProductsGroupHeaderItems>
      </OrderProductsGroupHeader>

      <div className="space-y-5">
        {group.products.map(product => {
          const orderedProducts = getOrderedProductsById(orderDetails, product.product);
          const orderedProductsDelwinIds = group.delwinIds.filter(delwinId =>
            orderedProducts.some(({ deliveryWindow }) => deliveryWindow === delwinId),
          );

          return (
            <OrderProduct
              key={product.product}
              productInfo={product}
              deliveryWindowIds={orderedProductsDelwinIds}
              stockTypeLabel={group.label}
            />
          );
        })}
      </div>
    </div>
  );
};
